// extracted by mini-css-extract-plugin
export var marginNegative = "_74-5 _74-3 _74-1";
export var marginPositive = "_74-4 _74-3 _74-1";
export var modalContent = "_74-6";
export var samplesTable = "_74-8";
export var samplesTableContainer = "_74-7";
export var statBox = "_74-a";
export var tableCell = "_74-1";
export var tableCellCenter = "_74-2 _74-1";
export var tableCellRight = "_74-3 _74-1";
export var tableHeader = "_74-0";
export var trackingNumber = "_74-9";